module.exports = __webpack_public_path__ + "img/文字版.1d94eb99.jpg";